import pp01 from 'assets/can-store/modernTemplate/pp01.jpg';
import pp02 from 'assets/can-store/modernTemplate/pp02.jpg';
import pp03 from 'assets/can-store/modernTemplate/pp03.jpg';
import pp04 from 'assets/can-store/modernTemplate/pp04.jpg';
import pp05 from 'assets/can-store/modernTemplate/pp05.jpg';
import pp06 from 'assets/can-store/modernTemplate/pp06.jpg';
import pp07 from 'assets/can-store/modernTemplate/pp07.jpg';
import pp08 from 'assets/can-store/modernTemplate/pp08.jpg';
// import pp09 from 'assets/can-store/modernTemplate/pp09.jpg';
// import pp10 from 'assets/can-store/modernTemplate/pp10.jpg';

/** @deprecated */
type PopularItem = { id: number; name: string; img: string; price: number; rating: number };

/** @deprecated */
const PopularItems: PopularItem[] = [
	{ id: 1, name: 'Golden Retriever', img: pp01, price: 33.99, rating: 5 },
	{ id: 2, name: 'Maine Coon Cat', img: pp02, price: 33.99, rating: 4 },
	{ id: 3, name: 'Brown Bear', img: pp03, price: 35.51, rating: 3 },
	{ id: 4, name: 'Beige', img: pp04, price: 20.34, rating: 2 },
	{ id: 5, name: 'Penguin', img: pp05, price: 24.99, rating: 1 },
	{ id: 6, name: 'Arctic Fox Flopsie', img: pp06, price: 18.36, rating: 5 },
	{ id: 7, name: 'German-Shepherd Dog', img: pp07, price: 59.96, rating: 4 },
	{ id: 8, name: 'Maizie Shepherd Dog', img: pp08, price: 62.99, rating: 3 },
	// { id: 9, name: 'Kodiak Black Bear', img: pp09, price: 38.95, rating: 2 },
	// { id: 10, name: 'Racoon,', img: pp10, price: 21.65, rating: 1 },
];

export default PopularItems;
